import ApiRequests from "../apiRequests";

class BlockService extends ApiRequests {
  constructor() {
    super("blocks");
  }
}

export default BlockService;
